import React from 'react';
import { Responsive } from '~/components';
import { Mobile, Desktop } from './responsive';

export default function MatchTeam({ ...props }) {
  return <Responsive md={<Mobile {...props} />} lg={<Desktop {...props} />} />;
}
